var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "39px",
    viewBox: "0 0 38 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TimelineIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPad-Pro-11---Patient-Information",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chart",
    transform: "translate(-52.000000, -142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(52.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#0a59a7",
    cx: 19,
    cy: 19.5135135,
    rx: 19,
    ry: 19.5135135
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "stethoscope"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1609375,4.5218747 C18.1171875,4.56875346 16.471875,6.27982825 16.5,8.32374224 C16.5234375,10.1145109 17.803125,11.6005677 19.5,11.9427826 L19.5,16.8931798 C19.5,19.9824902 16.809375,22.4951918 13.5,22.4951918 C10.190625,22.4951918 7.5,19.9824902 7.5,16.8931798 L7.5,16.4759588 C10.8703125,16.1009287 13.5,13.2366364 13.5,9.76760809 L13.5,1.20754628 C13.5,0.949713097 13.3265625,0.724695043 13.0734375,0.663752653 L10.4765625,0.0168257483 C10.1765625,-0.0581802696 9.871875,0.124646899 9.7921875,0.424670971 L9.703125,0.790325309 C9.628125,1.09034938 9.8109375,1.39506133 10.1109375,1.47475522 L12,1.94354284 L12,9.71604145 C12,12.6131489 9.6796875,15.0086536 6.7828125,15.0227172 C3.871875,15.0414687 1.5,12.6787792 1.5,9.77229596 L1.5,1.94354284 L3.384375,1.47006735 C3.684375,1.39506133 3.8671875,1.09034938 3.7921875,0.785637433 L3.703125,0.424670971 C3.628125,0.124646899 3.3234375,-0.0581802696 3.01875,0.0168257483 L0.4265625,0.663752653 C0.1734375,0.724695043 0,0.949713097 0,1.20754628 L0,9.76760809 C0,13.2366364 2.6296875,16.1009287 6,16.4759588 L6,16.8931798 C6,20.8122442 9.365625,24 13.5,24 C17.634375,24 21,20.8122442 21,16.8978677 L21,11.9474705 C22.7109375,11.6005677 24,10.0863837 24,8.2721756 C24,6.16731922 22.2703125,4.47030807 20.1609375,4.5218747 Z M20.25,10.5223561 C19.0078125,10.5223561 18,9.51446278 18,8.2721756 C18,7.02988843 19.0078125,6.02199506 20.25,6.02199506 C21.4921875,6.02199506 22.5,7.02988843 22.5,8.2721756 C22.5,9.51446278 21.4921875,10.5223561 20.25,10.5223561 Z M21.3515625,8.2721756 C21.3515625,8.8815995 20.859375,9.37382649 20.25,9.37382649 C19.640625,9.37382649 19.1484375,8.8815995 19.1484375,8.2721756 C19.1484375,7.66275171 19.640625,7.17052471 20.25,7.17052471 C20.859375,7.17052471 21.3515625,7.66275171 21.3515625,8.2721756 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineIcon);
export default __webpack_public_path__ + "static/media/TimelineIcon.1984d522c59e358384102365a2e6968a.svg";
export { ForwardRef as ReactComponent };